import React from 'react';

/**
 * @param  {string} {buttonStyle
 * @param  {any} children}
 */
// eslint-disable-next-line import/prefer-default-export
export const DokanButtons = ({
    buttonStyle,
    btnText = 'text-white',
    children,
    variant = 'secondary',
    ...rest
}) => {
    const buttonType = {
        primary: 'bg-button-primary',
        secondary: 'bg-button-secondary',
        tracking: 'bg-button-tracking',
        tertiary: 'bg-button-tertiary',
        success: 'bg-button-success',
    };
    return (
        <button
            className={`px-20px py-15px ${btnText} rounded-sm focus:outline-none text-sm font-normal ${buttonType[variant]} ${buttonStyle} `}
            type="button"
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...rest}
        >
            {children}
        </button>
    );
};
